// 生成数据列表
var navDataList = [{
        'menuId': "meta_table",
        'parentId': "",
        'parentName': null,
        'name': '元数据管理',
        'url': '/metadata/table_list',
        'perms': null,
        'type': 1,
        'orderNum': 1,
        'icon': "sql",
    }, {
        'menuId': "customform",
        'parentId': "",
        'parentName': null,
        'name': '自定义表单管理',
        'url': '/customform/list',
        'perms': null,
        'type': 1,
        'orderNum': 1,
        'icon': "editor",
    }, {
        'menuId': "datasourceconfig",
        'parentId': "",
        'parentName': null,
        'name': '数据源配置',
        'url': '/datasourceconfig/list',
        'perms': null,
        'type': 1,
        'orderNum': 1,
        'icon': "config",
    }, {
    'menuId': "camerasconfig",
    'parentId': "",
    'parentName': null,
    'name': '场地摄像头配置',
    'url': '/config/cameras_config_list',
    'perms': null,
    'type': 1,
    'orderNum': 1,
    'icon': "config",
    }, {
    'menuId': "warnItem",
    'parentId': "",
    'parentName': null,
    'name': '预警规则配置',
    'url': '/warnItem/warn_items_list',
    'perms': null,
    'type': 1,
    'orderNum': 1,
    'icon': "config",
    }
    , {
        'menuId': "flownodeconfig",
        'parentId': "",
        'parentName': null,
        'name': '业务流程节点配置',
        'url': '/config/flownode_config_list',
        'perms': null,
        'type': 1,
        'orderNum': 1,
        'icon': "config",
    }
    , {
        'menuId': "warnrecord",
        'parentId': "",
        'parentName': null,
        'name': '交易数据预警',
        'url': '/warnrecord/warn_record_list',
        'perms': null,
        'type': 1,
        'orderNum': 1,
        'icon': "config",
    }, {
        'menuId': "warnrecord-activity",
        'parentId': "",
        'parentName': null,
        'name': '交易活动预警',
        'url': '/warnrecord/warn_record_activity_list',
        'perms': null,
        'type': 1,
        'orderNum': 1,
        'icon': "config",
    }
    ]
    // 获取导航菜单列表 / 权限
export function nav() {
    return {
        // isOpen: false,
        url: '/loadMenus',
        type: 'post',
        data: {
            'msg': 'success',
            'code': "1",
            'menuList': navDataList,
            'permissions': [
                'sys:schedule:info',
            ]
        }
    }
}